import { AxiosError } from 'axios';

import { IRequestError } from '@/shared/types/app.types';

const SERVER_ERROR_TEXT = 'Попробуйте ещё раз или обратитесь в поддержку.';

// В 4xx бэкенд пишет понятную причину отказа, а в 5xx — внутренний текст исключения
export const getRequestErrorText = (error: AxiosError<IRequestError>, action: string) => {
	const status = error.response?.status;
	const message = error.response?.data?.message?.replace('Unhandled service exception:', '').trim();

	if (!status || status >= 500 || !message) {
		return `${action}. ${SERVER_ERROR_TEXT}`;
	}

	return message;
};
